import { isMember, modalColor } from "src/161759/utils"
import LeaderboardCompact from "src/components/LeaderboardCompact"
import VideoModal from "src/components/VideoModal"
import { DisplayOnce, ModalWrapper, TimeSwitch } from "src/utils/fw"

const timezone = "-05:00"

const dayOne = {
    name: "dayOne2024",
    starts: new Date(`2024-11-10 08:00:00${timezone}`),
    ends: new Date(`2024-11-10 23:59:00${timezone}`),
    content: <>
        <h1>WELCOME TO ORLANDO 2024 ONLINE: DAY ONE</h1>
        <p>Today's keynote speakers are Paul McKenna and Kate Darling.</p>

        <p>Visit the ISF Exploration Zone to access the latest reports and a wealth of resources available only to our Members, and tap into the knowledge of the ISF team.</p>

        <p>Visit the Exhibition Hall to learn how our sponsors can help you optimise managing your security landscape.</p>
    </>
}

const dayTwo = {
    name: "dayTwo2024",
    starts: new Date(`2024-11-11 08:45:00${timezone}`),
    ends: new Date(`2024-11-11 23:59:00${timezone}`),
    content: <>
        <h1>WELCOME TO ORLANDO 2024 ONLINE: DAY TWO</h1>
        <p>Today's keynote speakers are Duncan Wardle and Lesley Carhart.</p>
        <p>Visit the ISF Exploration Zone to access the latest reports and a wealth of resources available only to our Members and tap into the knowledge of the ISF team.</p>
        <p>Visit the Exhibition Hall to learn how our sponsors can help you optimise managing your security landscape.</p>
        <p>Go to our on-demand room to view yesterday's sessions.</p>
    </>
}

const dayThree = {
    name: "dayThree2024",
    starts: new Date(`2024-11-12 08:45:00${timezone}`),
    ends: new Date(`2024-11-12 12:00:00${timezone}`),
    content: <>
        <h1>WELCOME TO ORLANDO 2024 ONLINE: DAY THREE</h1>
        <p>Today's keynote speakers are Erik Avakian and Sylvie di Giusto.</p>
        <p>Go to our on-demand room to view previous sessions. All sessions will be available to view on-demand after today's broadcast.</p>
    </>
}

const finale = {
    name: "finale2024",
    starts: new Date(`2024-11-12 12:30:00${timezone}`),
    ends: new Date(`2026-11-12 12:59:00${timezone}`),
    content: <>
        <h1>THANK YOU FOR ATTENDING ORLANDO 2024 ONLINE</h1>
        <p>Following the event we will provide delegates with a certificate of attendance indicating the event date and times, which can be used to support your professional development.</p>
        <p>The maximum number of hours that can be achieved by attending all online sessions is 15 hours.</p>
        <p>Attendance certificates will be stored on your ISF Live profile and will be available for download approximately 15 working days after the event.</p>
        <p>The Congress platform will remain open until Tuesday 03 December for you to browse content and watch sessions on demand.</p>
    </>
}

export default <>
    { isMember && <LeaderboardCompact eventId="161759" quantity={3} style={{
        top: "53%",
        left: "71.6%",
        width: "13%",
        height: "14.5%"
    }} /> }
    <TimeSwitch>
        {[
            {
                name: "dayZero",
                starts: new Date(`2024-11-10 07:30:00${timezone}`),
                ends: new Date(`2024-11-10 07:59:00${timezone}`),
                content: null
            },
            dayOne,
            dayTwo,
            dayThree,
            finale
        ].map(it => {

            return {
                ...it,
                content: it.content && <DisplayOnce id={it.name} dismissHTML="X" dismissStyle={{color: "white", fontSize: "18px", top: "9px", right: "13px"}}>
                    <ModalWrapper wrapperStyle={{backgroundColor: modalColor, color: "white"}}>
                        {it.content}
                    </ModalWrapper>
                </DisplayOnce>
            }
        })}
    </TimeSwitch>
    <DisplayOnce id={"welcome2024"} dismissHTML="X" dismissStyle={{color: "white", fontSize: "18px", top: "9px", right: "13px"}}>
        <ModalWrapper wrapperStyle={{
            backgroundColor: modalColor, 
            color: "white",
            aspectRatio: "16 / 9",
            width: "50%",
            minWidth: "700px"}}>
            <VideoModal url="https://player.vimeo.com/video/991467648?autoplay=1" />
        </ModalWrapper>
    </DisplayOnce>
</>